<template>
  <div>
    <vue-file-toolbar-menu :content="menu" class="custom-toolbar" />
    <div class="scrollable">
      <div class ref="editor"></div>
    </div>
  </div>
</template>

<script>
import { Alignment } from "@ckeditor/ckeditor5-alignment";
import { Bold, Code, Italic, Strikethrough, Underline } from "@ckeditor/ckeditor5-basic-styles";
import { BlockQuote } from "@ckeditor/ckeditor5-block-quote";
import { ClassicEditor } from "@ckeditor/ckeditor5-editor-classic";
import { Essentials } from "@ckeditor/ckeditor5-essentials";
import { Font, FontFamily } from "@ckeditor/ckeditor5-font";
import { Heading } from "@ckeditor/ckeditor5-heading";
import { Indent } from "@ckeditor/ckeditor5-indent";
import { Link } from "@ckeditor/ckeditor5-link";
import { List } from "@ckeditor/ckeditor5-list";
import { PageBreak } from "@ckeditor/ckeditor5-page-break";
import { Paragraph } from "@ckeditor/ckeditor5-paragraph";
import { PasteFromOffice } from "@ckeditor/ckeditor5-paste-from-office";
import { Table, TableCellProperties, TableProperties, TableToolbar } from "@ckeditor/ckeditor5-table";
import VueFileToolbarMenu from "vue-file-toolbar-menu";
export default {
  props: ["hideMagic", "magicMenuType"],
  components: { VueFileToolbarMenu },

  data() {
    return {
      editorInstance: undefined,
      editorConfig: {
        plugins: [
          PageBreak,
          Alignment,
          BlockQuote,
          Bold,
          Underline,
          Strikethrough,
          Code,
          Essentials,
          Heading,
          Indent,
          Italic,
          Link,
          List,
          PasteFromOffice,
          Paragraph,
          Table,
          TableToolbar,
          TableCellProperties,
          TableProperties,
          Font,
          FontFamily,
        ],
        toolbar: [
          "Undo",
          "Redo",
          "Heading",
          "FontFamily",
          "FontSize",
          "FontColor",
          "FontBackgroundColor",
          "Bold",
          "Code",
          "Italic",
          "Underline",
          "StrikeThrough",
          "Link",
          "insertTable",
          "Blockquote",
          "Alignment",
          "BulletedList",
          "NumberedList",
          "Outdent",
          "Indent",
          "PageBreak",
        ],
        table: {
          contentToolbar: ["tableColumn", "tableRow", "mergeTableCells", "tableProperties", "tableCellProperties"],
        },
      },
      content: "<h1>&nbsp;</h1>",
    };
  },

  mounted() {
    ClassicEditor.create(this.$refs.editor, this.editorConfig)
      .then((editor) => {
        this.editorInstance = editor;
        this.editorInstance.setData(this.content);

        const tryRemovePoweredBy = () => {
          setTimeout(() => {
            const a = document.getElementsByClassName("ck-powered-by-balloon");
            if (a.length > 0) {
              a.forEach((i) => {
                i.remove();
                this.removed = true;
              });
            }
            if (!this.removed) {
              tryRemovePoweredBy();
            }
          }, 2000);
        };
        tryRemovePoweredBy();
      })
      .catch((error) => {
        console.error(error);
      });
  },
  computed: {
    menu() {
      let menu = [];

      if (!this.hideMagic) {
        if (this.magicMenuType == "report") {
          menu = [
            {
              // Magic menu
              text: this.$t("magic.title"),
              title: this.$t("magic.title"),
              icon: "auto_awesome",
              chevron: true,
              menu_width: 300,
              menu_class: "align-center",
              menu: [
                {
                  menu_width: 400,
                  text: this.$t("organization.text"),
                  icon: "auto_awesome",
                  menu: [
                    {
                      text: this.$t("magic.organization"),
                      icon: "tag",
                      click: () => {
                        this.insertText("#Organization#");
                      },
                    },
                    {
                      text: this.$t("magic.organization-title"),
                      icon: "tag",
                      click: () => {
                        this.insertText(`#Organization Title#`);
                      },
                    },
                  ],
                },
                {
                  menu_width: 400,
                  text: this.$t("magic.hierarchy"),
                  icon: "auto_awesome",
                  menu: [
                    {
                      text: this.$t("magic.unit-department-process-as-table"),
                      icon: "grid_on",
                      click: () => {
                        this.insertText("#Parent Unit and Unit and Process Table#");
                      },
                    },
                    {
                      text: this.$t("magic.department-process-datasource-as-table"),
                      icon: "grid_on",
                      click: () => {
                        this.insertText("#Unit and Process and Datasource Table#");
                      },
                    },
                    {
                      text: this.$t("magic.datasubject-category-as-table"),
                      icon: "grid_on",
                      click: () => {
                        this.insertText(`#Datasubject Category Based Datasubject Table#`);
                      },
                    },
                  ],
                },
                {
                  menu_width: 400,
                  text: this.$t("magic.task"),
                  icon: "auto_awesome",
                  menu: [
                    {
                      text: this.$t("magic.todo-and-unworked-tasks"),
                      icon: "grid_on",
                      click: () => {
                        this.insertText("#Tasks with To-Do and Unworked Status Tasks as Table#");
                      },
                    },
                  ],
                },

                {
                  menu_width: 400,
                  text: this.$t("magic.departments"),
                  icon: "auto_awesome",
                  menu: [
                    {
                      text: this.$t("magic.department-process-datasource-minimization-as-table"),
                      icon: "grid_on",
                      click: () => {
                        this.insertText(`#Collect Minimization Detail Table#`);
                      },
                    },
                    {
                      text: this.$t("magic.department-process-datasource-transfering-minimization-as-table"),
                      icon: "grid_on",
                      click: () => {
                        this.insertText(`#Transfering Minimization Detail Table#`);
                      },
                    },
                  ],
                },

                {
                  menu_width: 400,
                  text: this.$t("magic.processes"),
                  icon: "auto_awesome",
                  menu: [
                    {
                      text: this.$t("magic.process-as-list"),
                      icon: "grid_on",
                      click: () => {
                        this.insertText(`#Process List#`);
                      },
                    },
                    {
                      text: this.$t("magic.process-transfering-detail-as-table"),
                      icon: "grid_on",
                      click: () => {
                        this.insertText(`#Datasubject Based Transfering Detail Table#`);
                      },
                    },
                    {
                      text: this.$t("magic.process-risk-task-as-table"),
                      icon: "grid_on",
                      click: () => {
                        this.insertText(`#Risk Measure Task Detail Table#`);
                      },
                    },
                    {
                      text: this.$t("magic.process-task-as-table"),
                      icon: "grid_on",
                      click: () => {
                        this.insertText(`#Process and Task Table#`);
                      },
                    },
                    {
                      text: this.$t("magic.process-risk-detail-as-table"),
                      icon: "grid_on",
                      click: () => {
                        this.insertText(`#Risk Detail Table#`);
                      },
                    },
                  ],
                },

                {
                  menu_width: 400,
                  text: this.$t("magic.data-categories"),
                  icon: "auto_awesome",
                  menu: [
                    {
                      text: this.$t("magic.data-category-as-list"),
                      icon: "grid_on",
                      click: () => {
                        this.insertText(`#Data Category List#`);
                      },
                    },
                    {
                      text: this.$t("magic.data-category-processing-as-table"),
                      icon: "grid_on",
                      click: () => {
                        this.insertText(`#Data Category Based Processing Purpose Table#`);
                      },
                    },
                    {
                      text: this.$t("magic.data-category-storage-period-as-table"),
                      icon: "grid_on",
                      click: () => {
                        this.insertText(`#Data Category Based Storage Period Table#`);
                      },
                    },
                    {
                      text: this.$t("magic.data-category-datasubject-as-table"),
                      icon: "grid_on",
                      click: () => {
                        this.insertText(`#Data Category Based Datasubject Table#`);
                      },
                    },
                    {
                      text: this.$t("magic.data-category-datasubject-category-as-table"),
                      icon: "grid_on",
                      click: () => {
                        this.insertText(`#Data Category Based Datasubject Category Table#`);
                      },
                    },
                    {
                      text: this.$t("magic.data-category-and-personal-data-as-table"),
                      icon: "grid_on",
                      click: () => {
                        this.insertText(`#Data Category and Personal Data Table#`);
                      },
                    },
                    {
                      text: this.$t("magic.data-category-abroad-transfering-as-table"),
                      icon: "grid_on",
                      click: () => {
                        this.insertText(`#Data Category Based Abroad Transfering Table#`);
                      },
                    },
                  ],
                },

                {
                  menu_width: 400,
                  text: this.$t("magic.datasubjects"),
                  icon: "auto_awesome",
                  menu: [
                    {
                      text: this.$t("magic.datasubject-data-category-process-detail-as-table"),
                      icon: "grid_on",
                      click: () => {
                        this.insertText(`#Datasubject Based Process Data Category Table#`);
                      },
                    },
                    {
                      text: this.$t("magic.data-subject-processing-as-table"),
                      icon: "grid_on",
                      click: () => {
                        this.insertText(`#Data Subject Based Processing Purpose Table#`);
                      },
                    },
                    {
                      text: this.$t("magic.data-subject-processing-legal-detailed-as-list"),
                      icon: "grid_on",
                      click: () => {
                        this.insertText(`#Data Subject Based Processing Legal Detailed List#`);
                      },
                    },
                    {
                      text: this.$t("magic.datasubject-process-collect-detail-as-table"),
                      icon: "grid_on",
                      click: () => {
                        this.insertText(`#Datasubject Based Process Collect Method Table#`);
                      },
                    },
                    {
                      text: this.$t("magic.datasubject-process-legal-detail-as-table"),
                      icon: "grid_on",
                      click: () => {
                        this.insertText(`#Datasubject Based Process Legal Reason Table#`);
                      },
                    },
                  ],
                },

                {
                  menu_width: 400,
                  text: this.$t("magic.policy"),
                  icon: "auto_awesome",
                  menu: [
                    {
                      text: this.$t("magic.policy-as-list"),
                      icon: "list",
                      click: () => {
                        this.insertText(`#Measures Detail List#`);
                      },
                    },
                    {
                      text: this.$t("magic.policy-as-table"),
                      icon: "grid_on",
                      click: () => {
                        this.insertText(`#Measures Detail Table#`);
                      },
                    },
                    {
                      text: this.$t("magic.legal-policy-as-list"),
                      icon: "list",
                      click: () => {
                        this.insertText(`#Legal Measures as List#`);
                      },
                    },
                    {
                      text: this.$t("magic.administrative-policy-as-list"),
                      icon: "list",
                      click: () => {
                        this.insertText(`#Organisational Measures as List#`);
                      },
                    },
                    {
                      text: this.$t("magic.administrative-policy-as-table"),
                      icon: "grid_on",
                      click: () => {
                        this.insertText(`#Organisational Measures as Table#`);
                      },
                    },
                    {
                      text: this.$t("magic.technical-policy-as-list"),
                      icon: "list",
                      click: () => {
                        this.insertText(`#Technical Measures as List#`);
                      },
                    },
                    {
                      text: this.$t("magic.technical-policy-as-table"),
                      icon: "grid_on",
                      click: () => {
                        this.insertText(`#Technical Measures as Table#`);
                      },
                    },
                    {
                      text: this.$t("magic.policy-not-applied-detail-as-table"),
                      icon: "grid_on",
                      click: () => {
                        this.insertText(`#Measures as Not Applying and Risk Task Detail Table#`);
                      },
                    },
                    {
                      text: this.$t("magic.policy-applied-detail-as-table"),
                      icon: "grid_on",
                      click: () => {
                        this.insertText(`#Measures as Applying and Task Detail Table#`);
                      },
                    },
                  ],
                },
                {
                  menu_width: 400,
                  text: this.$t("magic.storage"),
                  icon: "auto_awesome",
                  menu: [
                    {
                      text: this.$t("magic.physical-storage-list-as-bullet"),
                      icon: "list",
                      click: () => {
                        this.insertText(`#Physical Storages as List#`);
                      },
                    },
                    {
                      text: this.$t("magic.electronic-storage-list-as-bullet"),
                      icon: "list",
                      click: () => {
                        this.insertText(`#Electronic Storages as List#`);
                      },
                    },
                  ],
                },
                {
                  text: this.$t("magic.product"),
                  icon: "tag",
                  click: () => {
                    this.insertText(`#Product#`);
                  },
                },
                {
                  text: this.$t("magic.receiver-group-as-list"),
                  icon: "grid_on",
                  click: () => {
                    this.insertText(`#Receiver Group List#`);
                  },
                },
                {
                  text: this.$t("magic.personal-data-processing-purpose-as-list"),
                  icon: "grid_on",
                  click: () => {
                    this.insertText(`#Personal Data Processing Purpose List#`);
                  },
                },
                {
                  text: this.$t("magic.receiver-group-and-third-party-as-table"),
                  icon: "grid_on",
                  click: () => {
                    this.insertText(`#Receiver Group and Third Party Table#`);
                  },
                },
                {
                  text: this.$t("magic.data-transfering-abroad-as-list"),
                  icon: "list",
                  click: () => {
                    this.insertText(`#Data Transfering to Abroad List#`);
                  },
                },
              ],
            },
          ];
        } else {
          menu = [
            {
              // Magic menu
              text: this.$t("magic.title"),
              title: this.$t("magic.title"),
              icon: "auto_awesome",
              chevron: true,
              menu_width: 300,
              menu_class: "align-center",
              menu: [
                {
                  text: this.$t("magic.product"),
                  icon: "auto_awesome",
                  click: () => {
                    this.insertText(`#Product#`);
                  },
                },
                {
                  menu_width: 400,
                  text: this.$t("organization.text"),
                  icon: "auto_awesome",
                  menu: [
                    {
                      text: this.$t("magic.organization"),
                      icon: "tag",
                      click: () => {
                        this.insertText("#Organization#");
                      },
                    },
                    {
                      text: this.$t("magic.organization-title"),
                      icon: "tag",
                      click: () => {
                        this.insertText(`#Organization Title#`);
                      },
                    },
                    {
                      text: this.$t("magic.organization-address"),
                      icon: "tag",
                      click: () => {
                        this.insertText(`#Organization Address#`);
                      },
                    },
                    {
                      text: this.$t("magic.organization-web"),
                      icon: "tag",
                      click: () => {
                        this.insertText(`#Organization Website#`);
                      },
                    },
                    {
                      text: this.$t("magic.organization-kep"),
                      icon: "tag",
                      click: () => {
                        this.insertText(`#Organization Kep Address#`);
                      },
                    },
                    {
                      text: this.$t("magic.organization-email-address"),
                      icon: "tag",
                      click: () => {
                        this.insertText(`#Organization Email Address#`);
                      },
                    },
                    {
                      text: this.$t("magic.organization-phone"),
                      icon: "tag",
                      click: () => {
                        this.insertText(`#Organization Phone#`);
                      },
                    },

                    {
                      text: this.$t("magic.organization-contact-name"),
                      icon: "tag",
                      click: () => {
                        this.insertText(`#Organization Contact Name#`);
                      },
                    },
                    {
                      text: this.$t("magic.organization-contact-address"),
                      icon: "tag",
                      click: () => {
                        this.insertText(`#Organization Contact Address#`);
                      },
                    },
                    {
                      text: this.$t("magic.organization-contact-email"),
                      icon: "tag",
                      click: () => {
                        this.insertText(`#Organization Contact Email#`);
                      },
                    },

                    {
                      text: this.$t("magic.organization-contact-phone"),
                      icon: "tag",
                      click: () => {
                        this.insertText(`#Organization Contact Phone#`);
                      },
                    },
                  ],
                },

                {
                  menu_width: 400,
                  text: this.$t("department.text"),
                  icon: "auto_awesome",
                  menu: [
                    {
                      text: this.$t("magic.department"),
                      icon: "tag",
                      click: () => {
                        this.insertText(`#Unit#`);
                      },
                    },
                    {
                      text: this.$t("magic.department-list-as-bullet"),
                      icon: "list",
                      click: () => {
                        this.insertText(`#Units as List#`);
                      },
                    },
                    {
                      text: this.$t("magic.department-list-as-comma"),
                      icon: "linear_scale",
                      click: () => {
                        this.insertText(`#Units as Comma#`);
                      },
                    },
                  ],
                },

                {
                  menu_width: 400,
                  text: this.$t("process.text"),
                  icon: "auto_awesome",
                  menu: [
                    {
                      text: this.$t("magic.process"),
                      icon: "tag",
                      click: () => {
                        this.insertText(`#Process#`);
                      },
                    },
                    {
                      text: this.$t("magic.process-list-as-bullet"),
                      icon: "list",
                      click: () => {
                        this.insertText(`#Processes as List#`);
                      },
                    },
                    {
                      text: this.$t("magic.process-list-as-comma"),
                      icon: "linear_scale",
                      click: () => {
                        this.insertText(`#Processes as Comma#`);
                      },
                    },

                    {
                      text: this.$t("magic.process-and-storage-as-table"),
                      icon: "grid_on",
                      click: () => {
                        this.insertText(`#Process and Storage as Table#`);
                      },
                    },
                    {
                      text: this.$t("magic.transfering-process-and-storage-as-table"),
                      icon: "grid_on",
                      click: () => {
                        this.insertText(`#Transfering Process and Storage as Table#`);
                      },
                    },
                    {
                      text: this.$t("magic.process-description-as-table"),
                      icon: "grid_on",
                      click: () => {
                        this.insertText(`#Process Description as Table#`);
                      },
                    },
                  ],
                },

                {
                  menu_width: 400,
                  text: this.$t("datasource.text"),
                  icon: "auto_awesome",
                  menu: [
                    {
                      text: this.$t("magic.datasource"),
                      icon: "tag",
                      click: () => {
                        this.insertText(`#Datasource#`);
                      },
                    },
                    {
                      text: this.$t("magic.datasource-list-as-bullet"),
                      icon: "list",
                      click: () => {
                        this.insertText(`#Datasources as List#`);
                      },
                    },
                    {
                      text: this.$t("magic.datasource-list-as-comma"),
                      icon: "linear_scale",
                      click: () => {
                        this.insertText(`#Datasources as Comma#`);
                      },
                    },
                  ],
                },
                {
                  menu_width: 400,
                  text: this.$t("data-category.text"),
                  icon: "auto_awesome",
                  menu: [
                    {
                      text: this.$t("magic.data-category"),
                      icon: "tag",
                      click: () => {
                        this.insertText(`#Data Category#`);
                      },
                    },
                    {
                      text: this.$t("magic.data-category-list-as-bullet"),
                      icon: "list",
                      click: () => {
                        this.insertText(`#Data Categories as List#`);
                      },
                    },
                    {
                      text: this.$t("magic.data-category-list-as-comma"),
                      icon: "linear_scale",
                      click: () => {
                        this.insertText(`#Data Categories as Comma#`);
                      },
                    },

                    {
                      text: this.$t("magic.data-category-transfering-purpose-list-as-table"),
                      icon: "grid_on",
                      click: () => {
                        this.insertText(`#Data Category Transfering Purpose as Table#`);
                      },
                    },
                  ],
                },
                {
                  menu_width: 400,
                  text: this.$t("data.text"),
                  icon: "auto_awesome",
                  menu: [
                    {
                      text: this.$t("magic.data"),
                      icon: "tag",
                      click: () => {
                        this.insertText(`#Data#`);
                      },
                    },
                    {
                      text: this.$t("magic.data-list-as-bullet"),
                      icon: "list",
                      click: () => {
                        this.insertText(`#Datas as List#`);
                      },
                    },
                    {
                      text: this.$t("magic.data-list-as-comma"),
                      icon: "linear_scale",
                      click: () => {
                        this.insertText(`#Datas as Comma#`);
                      },
                    },

                    {
                      text: this.$t("magic.data-as-table"),
                      icon: "grid_on",
                      click: () => {
                        this.insertText(`#Datas as Table#`);
                      },
                    },

                    {
                      text: this.$t("magic.special-data-list-as-bullet"),
                      icon: "list",
                      click: () => {
                        this.insertText(`#Sensitive Datas as List#`);
                      },
                    },

                    {
                      text: this.$t("magic.special-data-list-as-comma"),
                      icon: "linear_scale",
                      click: () => {
                        this.insertText(`#Sensitive Datas as Comma#`);
                      },
                    },

                    {
                      text: this.$t("magic.special-data-as-table"),
                      icon: "grid_on",
                      click: () => {
                        this.insertText(`#Sensitive Datas as Table#`);
                      },
                    },
                  ],
                },
                {
                  menu_width: 400,
                  text: this.$t("datasubject.text"),
                  icon: "auto_awesome",
                  menu: [
                    {
                      text: this.$t("magic.datasubject"),
                      icon: "tag",
                      click: () => {
                        this.insertText(`#Datasubject#`);
                      },
                    },
                    {
                      text: this.$t("magic.datasubject-list-as-bullet"),
                      icon: "list",
                      click: () => {
                        this.insertText(`#Datasubjects as List#`);
                      },
                    },
                    {
                      text: this.$t("magic.datasubject-list-as-comma"),
                      icon: "linear_scale",
                      click: () => {
                        this.insertText(`#Datasubjects as Comma#`);
                      },
                    },
                  ],
                },
                {
                  menu_width: 400,
                  text: this.$t("thirdparty.text"),
                  icon: "auto_awesome",
                  menu: [
                    {
                      text: this.$t("magic.third-party"),
                      icon: "tag",
                      click: () => {
                        this.insertText(`#Third Party#`);
                      },
                    },
                    {
                      text: this.$t("magic.third-party-country"),
                      icon: "tag",
                      click: () => {
                        this.insertText(`#Third Party Country#`);
                      },
                    },
                    {
                      text: this.$t("magic.third-party-agreement"),
                      icon: "tag",
                      click: () => {
                        this.insertText(`#Third Party Agreement#`);
                      },
                    },
                    {
                      text: this.$t("magic.third-party-agreement-list-as-bullet"),
                      icon: "list",
                      click: () => {
                        this.insertText(`#Third Party Agreement as List#`);
                      },
                    },
                    {
                      text: this.$t("magic.third-party-list-as-bullet"),
                      icon: "list",
                      click: () => {
                        this.insertText(`#Third Parties as List#`);
                      },
                    },
                    {
                      text: this.$t("magic.third-party-list-as-comma"),
                      icon: "linear_scale",
                      click: () => {
                        this.insertText(`#Third Parties as Comma#`);
                      },
                    },
                    {
                      text: this.$t("magic.third-party-transfering-purpose-list-as-bullet"),
                      icon: "list",
                      click: () => {
                        this.insertText(`#Third Party Transfering Purposes as List#`);
                      },
                    },
                    {
                      text: this.$t("magic.third-party-receiver-group-transfering-purpose-list-as-table"),
                      icon: "grid_on",
                      click: () => {
                        this.insertText(`#Third Party Receiver Groups Transfering Purpose as Table#`);
                      },
                    },
                    {
                      text: this.$t("magic.third-party-transfering-purpose-list-as-table"),
                      icon: "grid_on",
                      click: () => {
                        this.insertText(`#Third Party Transfering Purposes as Table#`);
                      },
                    },
                    {
                      text: this.$t("magic.third-party-data-category-transfering-purpose-list-as-table"),
                      icon: "grid_on",
                      click: () => {
                        this.insertText(`#Third Party Data Category Transfering Purposes as Table#`);
                      },
                    },
                    {
                      text: this.$t("magic.third-party-transfering-legal-list-as-bullet"),
                      icon: "list",
                      click: () => {
                        this.insertText(`#Third Party Transfering Legal Reasons as List#`);
                      },
                    },
                    {
                      text: this.$t("magic.third-party-transfering-legal-list-as-table"),
                      icon: "grid_on",
                      click: () => {
                        this.insertText(`#Third Party Transfering Legal Reasons as Table#`);
                      },
                    },
                    {
                      text: this.$t("magic.third-party-transfering-prevention-list-as-table"),
                      icon: "grid_on",
                      click: () => {
                        this.insertText(`#Third Party Transfering Preventions as Table#`);
                      },
                    },
                    {
                      text: this.$t("magic.third-party-transfering-method-list-as-table"),
                      icon: "grid_on",
                      click: () => {
                        this.insertText(`#Third Party Transfering Methods as Table#`);
                      },
                    },
                  ],
                },
                {
                  menu_width: 400,
                  text: this.$t("receiver-group.text"),
                  icon: "auto_awesome",
                  menu: [
                    {
                      text: this.$t("magic.receiver-group-list-as-bullet"),
                      icon: "list",
                      click: () => {
                        this.insertText(`#Receiver Groups as List#`);
                      },
                    },
                    {
                      text: this.$t("magic.transfering-receiver-group-list-as-bullet"),
                      icon: "list",
                      click: () => {
                        this.insertText(`#Transfering Receiver Groups as List#`);
                      },
                    },
                    {
                      text: this.$t("magic.receiver-group-transfering-purpose-list-as-table"),
                      icon: "grid_on",
                      click: () => {
                        this.insertText(`#Receiver Groups Transfering Purpose as Table#`);
                      },
                    },
                    {
                      text: this.$t("magic.receiver-group-third-parties-transfering-purpose-list-as-table"),
                      icon: "grid_on",
                      click: () => {
                        // this.insertText(`#Receiver Groups Transfering Purpose as Table#`);
                        this.insertText(`#Receiver Group Third Parties Transfering Purpose as Table#`);
                      },
                    },
                    {
                      text: this.$t("magic.receiver-group-data-category-transfering-purpose-list-as-table"),
                      icon: "grid_on",
                      click: () => {
                        // this.insertText(`#Receiver Groups Transfering Purpose as Table#`);
                        this.insertText(`#Receiver Group Data Category Transfering Purpose as Table#`);
                      },
                    },
                  ],
                },
                {
                  menu_width: 400,
                  text: this.$t("magic.policy"),
                  icon: "auto_awesome",
                  menu: [
                    {
                      text: this.$t("magic.administrative-policy-as-list"),
                      icon: "list",
                      click: () => {
                        this.insertText(`#Organisational Measures as List#`);
                      },
                    },
                    {
                      text: this.$t("magic.administrative-policy-as-table"),
                      icon: "grid_on",
                      click: () => {
                        this.insertText(`#Organisational Measures as Table#`);
                      },
                    },
                    {
                      text: this.$t("magic.technical-policy-as-list"),
                      icon: "list",
                      click: () => {
                        this.insertText(`#Technical Measures as List#`);
                      },
                    },
                    {
                      text: this.$t("magic.technical-policy-as-table"),
                      icon: "grid_on",
                      click: () => {
                        this.insertText(`#Technical Measures as Table#`);
                      },
                    },
                  ],
                },
                {
                  menu_width: 400,
                  text: this.$t("magic.storage"),
                  icon: "auto_awesome",
                  menu: [
                    {
                      text: this.$t("magic.physical-storage-list-as-bullet"),
                      icon: "list",
                      click: () => {
                        this.insertText(`#Physical Storages as List#`);
                      },
                    },
                    {
                      text: this.$t("magic.electronic-storage-list-as-bullet"),
                      icon: "list",
                      click: () => {
                        this.insertText(`#Electronic Storages as List#`);
                      },
                    },
                  ],
                },
                {
                  menu_width: 400,
                  text: this.$t("magic.collect-method"),
                  icon: "auto_awesome",
                  menu: [
                    {
                      text: this.$t("magic.collect-method-list-as-bullet"),
                      icon: "list",
                      click: () => {
                        this.insertText(`#Collect Methods as List#`);
                      },
                    },
                    {
                      text: this.$t("magic.collect-method-list-as-comma"),
                      icon: "linear_scale",
                      click: () => {
                        this.insertText(`#Collect Methods as Comma#`);
                      },
                    },

                    {
                      text: this.$t("magic.collect-method-list-as-table"),
                      icon: "grid_on",
                      click: () => {
                        this.insertText(`#Collect Methods as Table#`);
                      },
                    },
                  ],
                },
                {
                  menu_width: 400,
                  text: this.$t("magic.processing"),
                  icon: "auto_awesome",
                  menu: [
                    {
                      text: this.$t("magic.processing-purpose-list-as-bullet"),
                      icon: "list",
                      click: () => {
                        this.insertText(`#Processing Purposes as List#`);
                      },
                    },
                    {
                      text: this.$t("magic.processing-purpose-list-as-table"),
                      icon: "grid_on",
                      click: () => {
                        this.insertText(`#Processing Purposes as Table#`);
                      },
                    },
                    {
                      text: this.$t("magic.processing-legal-reason-list-as-bullet"),
                      icon: "list",
                      click: () => {
                        this.insertText(`#Processing Legal Reasons as List#`);
                      },
                    },
                    {
                      text: this.$t("magic.processing-legal-reason-and-category-as-table"),
                      icon: "list",
                      click: () => {
                        this.insertText(`#Processing Legal Reasons and Data Categories as Table#`);
                      },
                    },
                    {
                      text: this.$t("magic.data-category-processing-purpose-as-table"),
                      icon: "grid_on",
                      click: () => {
                        this.insertText(`#Data Category Processing Purposes as Table#`);
                      },
                    },
                    {
                      text: this.$t("magic.processing-purpose-data-category-as-table"),
                      icon: "grid_on",
                      click: () => {
                        this.insertText(`#Processing Purpose Data Categories as Table#`);
                      },
                    },
                    {
                      text: this.$t("magic.processing-legal-reason-data-category-processing-purpose-as-table"),
                      icon: "grid_on",
                      click: () => {
                        this.insertText(`#Processing Legal Reason and Data Category and Processing Purpose as Table#`);
                      },
                    },
                    {
                      text: this.$t("magic.processing-legal-reason-and-data-and-processing-purpose-as-table"),
                      icon: "grid_on",
                      click: () => {
                        this.insertText(`#Processing Legal Reason and Data and Processing Purpose as Table#`);
                      },
                    },
                    {
                      text: this.$t("magic.processing-legal-reason-and-data-category-and-data-processing-purpose-as-table"),
                      icon: "grid_on",
                      click: () => {
                        this.insertText(`#Processing Legal Reason and Data Category and Data and Processing Purpose as Table#`);
                      },
                    },
                    {
                      text: this.$t("magic.datasubject-processing-legal-reason-and-category-as-table"),
                      icon: "grid_on",
                      click: () => {
                        this.insertText(`#Datasubject and Processing Legal Reasons and Data Categories as Table#`);
                      },
                    },
                    {
                      text: this.$t("magic.legal-reason-and-data-category-based-processing-purpose-and-personal-data-as-table"),
                      icon: "grid_on",
                      click: () => {
                        this.insertText(`#Legal Reason and Data Category Based Processing Purpose and Personal Data as Table#`);
                      },
                    },
                  ],
                },
              ],
            },
          ];
        }
      }

      return menu;
    },
  },

  watch: {
    content: {
      handler(new_content) {
        if (this.editorInstance) {
          this.editorInstance.setData(new_content[0]);
        }
      },
    },
  },

  methods: {
    rePositionStickyElement() {
      const topBar = document.getElementById("page-topbar");
      const stickyElement = document.querySelector(".sticky");
      if (topBar) {
        stickyElement.style.top = topBar.clientHeight + "px";
      }
    },
    getEditorContent() {
      return this.editorInstance.getData();
    },

    insertText(text) {
      const selection = this.editorInstance.model.document.selection;
      const range = selection.getFirstRange();
      this.editorInstance.model.change((writer) => {
        writer.insert(text, range.start);
      });
    },
  },
};
</script>

<style lang="css">
.scrollable {
  position: relative;
  height: 1200px;
  overflow: auto;
}
.bar-button.open:hover {
  z-index: 99999999 !important;
}
.bar-button > .menu.align-center {
  left: 0 !important;
}
.custom-toolbar .bar-menu-item {
  font-size: 16px;
  padding: 4, 4, 4;
}
</style>
